module.exports = __webpack_public_path__ + "img/process-img-2.d548bf63.png";